import { useState } from 'react'
import Layout from '../components/Layout'
import AddressList from '../components/AddressList'
import EmailList from '../components/EmailList'
import EmailViewer from '../components/EmailViewer'
import ApiKeyManager from '../components/ApiKeyManager'
import MfaDeviceManager from '../components/MfaDeviceManager'

function DashboardPage() {
  const [view, setView] = useState('addresses') // 'addresses' | 'emails' | 'email' | 'apikeys' | 'mfa'
  const [selectedAddress, setSelectedAddress] = useState(null)
  const [selectedEmail, setSelectedEmail] = useState(null)

  const handleViewEmails = (address) => {
    setSelectedAddress(address)
    setView('emails')
  }

  const handleManageKeys = (address) => {
    setSelectedAddress(address)
    setView('apikeys')
  }

  const handleViewEmail = (email) => {
    setSelectedEmail(email)
    setView('email')
  }

  const handleManageMFA = () => {
    setView('mfa')
  }

  const handleBackToAddresses = () => {
    setSelectedAddress(null)
    setSelectedEmail(null)
    setView('addresses')
  }

  const handleBackToEmails = () => {
    setSelectedEmail(null)
    setView('emails')
  }

  return (
    <Layout>
      {view === 'addresses' && (
        <AddressList
          onViewEmails={handleViewEmails}
          onManageKeys={handleManageKeys}
          onManageMFA={handleManageMFA}
        />
      )}
      {view === 'emails' && selectedAddress && (
        <EmailList
          address={selectedAddress}
          onBack={handleBackToAddresses}
          onViewEmail={handleViewEmail}
        />
      )}
      {view === 'email' && selectedAddress && selectedEmail && (
        <EmailViewer
          email={selectedEmail}
          address={selectedAddress}
          onBack={handleBackToEmails}
        />
      )}
      {view === 'apikeys' && selectedAddress && (
        <ApiKeyManager
          address={selectedAddress}
          onBack={handleBackToAddresses}
        />
      )}
      {view === 'mfa' && (
        <MfaDeviceManager onBack={handleBackToAddresses} />
      )}
    </Layout>
  )
}

export default DashboardPage
